/**
 * apiError - read the machine-readable code and the human message off an axios
 * rejection.
 *
 * The API is inconsistent about where a code lands: the canonical role service
 * answers `{ code: 'ROLE_ALREADY_ACTIVE', message }`, while the compliance
 * endpoints answer `{ message: 'already_claimed' }` with no `code` field at all
 * (ManualPaymentConfirm hit the same split with `settlement_refused`). Screens
 * that map codes to copy should never have to know which shape they got, so
 * this reads `code` first and falls back to `message`.
 */
export function apiErrorCode(err) {
  const body = err?.response?.data || {};
  // Three shapes, all live at once, in this order of specificity:
  //   `code`    the canonical role service  { code: 'ROLE_ALREADY_ACTIVE' }
  //   `error`   the auth middleware         { status:false, error:'role_forbidden' }
  //   `message` the compliance controllers  { status:409, message:'self_review' }
  // Reading only two of the three left every authz refusal uncoded, which is
  // exactly the class of failure that most needs its own copy.
  return body.code || body.error || body.message || null;
}

/** apiErrorMessage - the message to show when no code mapping applies. */
export function apiErrorMessage(err, fallback = "Request failed") {
  return err?.response?.data?.message || err?.message || fallback;
}

/** apiStatus - the HTTP status, or null for a transport failure. */
export function apiStatus(err) {
  return err?.response?.status ?? null;
}
